/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Report_Geography_TitleInputs */

const vi_report_geography_title = /** @type {(inputs: Report_Geography_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doanh thu theo địa lý (Top 5 tỉnh/thành)`)
};

/**

* @param {Report_Geography_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const report_geography_title = /** @type {((inputs?: Report_Geography_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_Geography_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_report_geography_title(inputs)
});